// #region imports

// --- Angular
import { Component, Input, ChangeDetectionStrategy, ElementRef } from '@angular/core';

// -- HS Code
import { NavBarBaseComponent } from '../../../core/nav-bar/nav-bar-base.component';
//import {environment} from '../../../../environments/environment';

// #endregion

@Component({
  selector: 'hs-registration-nav',
  templateUrl: './registration-nav.component.html',
  styleUrls: ['./registration-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistrationNavComponent extends NavBarBaseComponent {
  @Input() isRegistered: boolean;
  //LOGIN_URL: string = environment.authSettings.authority + '/Account/login' ;
  constructor(elementRef: ElementRef) {
    super(elementRef);
  }
}
